import React from 'react';
import styled from 'styled-components';

import MaterialIcon from '../../../shared/common/MaterialIcon';
import { flex } from '../../../styles/utilities/flex';

const StWrapper = styled.div`
    ${flex()};
    font-weight: bold;
    align-items: center;
`;
interface Props {
    isLibxTitle: boolean;
}
const LibxTitleInfoLine = (props: Props) => {
    if (!props.isLibxTitle) return null;

    return (
        <StWrapper>
            <MaterialIcon icon="place" />
            {'\u00A0'}LIBXchange Title
        </StWrapper>
    );
};

export default LibxTitleInfoLine;
